import React from 'react';
import classnames from 'classnames/bind';
import { useMediaQuery } from "../../../../hooks";
import { TextBase } from "../../../../internal/TextBase";
import Picture404 from './Picture404.jpg';
import styles from './SearchNotFound.css';
var cx = classnames.bind(styles);
export var SearchNotFound = function SearchNotFound(_ref) {
  var subtitle = _ref.subtitle,
      title = _ref.title,
      showPicture = _ref.showPicture;
  var breakpoints = useMediaQuery('xs');
  var isMobile = breakpoints.xs;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('root')
  }, /*#__PURE__*/React.createElement(TextBase, {
    as: "span",
    size: isMobile ? 'l' : 'xl',
    weight: "semibold"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: cx('subtitle')
  }, /*#__PURE__*/React.createElement(TextBase, {
    as: "span",
    color: "N300",
    size: isMobile ? 's' : 'l'
  }, subtitle)), showPicture && /*#__PURE__*/React.createElement("div", {
    className: cx('image')
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Not found",
    src: Picture404
  })));
};